import Vue from "vue";
import { Component, Prop, Emit } from 'vue-property-decorator'
import HyroxRoundPreviewComponent from "../hyrox-round-preview/hyrox-round-preview.component.vue";
import { MssHyroxMainPart } from "@/types/workouts";
import { PAGES } from "@/types/router";

@Component({
    components: {
        'hyrox-round-preview': HyroxRoundPreviewComponent
    }
})
export default class HyroxZonePreviewComponent extends Vue {
    @Prop({ type: Object, default: []}) slides!: MssHyroxMainPart
    @Prop({ type: Number, default: 1}) index!: number
    @Prop({ type: Boolean, default: true}) collapsed!: boolean

    public zoneActive = 0
    public partActive = 0

    get accordionId() {
        return this.slides.workout_id + this.index
    }

    get zones() {
        return this.slides.zones
    }

    get activeClassZone() {
        return ['theme-style round-active-color', 'active-zone', 'primary-color-text']
    }

    get activeZone() {
        return this.zoneActive
    }

    get title() {
        return this.$route.name === PAGES.VELOCITY_WORKOUT_DESCRIPTION ? 'Velocity' : 'Hyrox'
    }

    mounted() {
        this.partActive = this.index
    }

    @Emit()
    onSlideChange() {
        const data = {
            roundIdx: 0,
            workoutPartIdx: this.index
        }
        return data
    }

    renderZone(index: number) {
        this.zoneActive = index
        this.onSlideChange()
    }
}